/**
 * Process section: Splide carousel below 768px; destroyed ≥768 (CSS grid).
 */
(function () {
  function initProcessSection(root) {
    const ctx = root && root.querySelectorAll ? root : document;

    if (typeof Splide === "undefined") {
      setTimeout(function () {
        initProcessSection(root);
      }, 100);
      return;
    }

    ctx.querySelectorAll("[data-process-slider]").forEach(function (section) {
      const el = section.querySelector(".process-section__splide");
      if (!el) {
        return;
      }

      if (el.__splideInstance) {
        try {
          el.__splideInstance.destroy(true);
        } catch (e) {
          /* ignore */
        }
        el.__splideInstance = null;
      }

      try {
        const splide = new Splide(el, {
          type: "slide",
          rewind: true,
          perPage: 1,
          gap: "20px",
          arrows: false,
          pagination: false,
          mediaQuery: "min",
          breakpoints: {
            768: {
              destroy: true,
            },
          },
        });

        splide.mount();
        el.__splideInstance = splide;

        if (!section.__processArrowDelegation) {
          section.__processArrowDelegation = true;
          section.addEventListener("click", function (ev) {
            const splideEl = section.querySelector(".process-section__splide");
            const inst = splideEl && splideEl.__splideInstance;
            if (!inst) {
              return;
            }
            if (ev.target.closest(".process-section__arrow--prev")) {
              inst.go("<");
            }
            if (ev.target.closest(".process-section__arrow--next")) {
              inst.go(">");
            }
          });
        }

        splide.on("destroy", function () {
          el.__splideInstance = null;
        });
      } catch (err) {
        /* silent */
      }
    });
  }

  if (typeof wp !== "undefined" && wp.domReady) {
    wp.domReady(function () {
      initProcessSection(document);
    });
  } else if (typeof jQuery !== "undefined") {
    jQuery(function () {
      initProcessSection(document);
    });
  } else {
    document.addEventListener("DOMContentLoaded", function () {
      initProcessSection(document);
    });
  }

  if (typeof acf !== "undefined" && typeof acf.addAction === "function") {
    acf.addAction("render_block_preview/type=process-section", function ($block) {
      const el = $block && $block[0] ? $block[0] : null;
      initProcessSection(el || document);
    });
  }
})();
